import _ from 'lodash';
import {INIT_NEWS} from '../initFormData';

const actions = {
    initNews: (draft, {id, appId, newsById = {}, currentTmpId, tmpIds} = {}) => {
        draft.id = id;
        draft.appId = appId;
        draft.newsById = newsById;
        draft.currentTmpId = currentTmpId;
        draft.tmpIds = tmpIds;
    },

    changeAppId: (draft, appId) => {
        draft.appId = appId;
        draft.dirty = true;
    },

    updateCurrentNewsForm: (draft, {currentTmpId, news}) => {
        draft.newsById[currentTmpId] = news;
        draft.dirty = true;
    },

    updateEntrypointPaths: (draft, entrypoint) => {
        draft.entrypointsById[draft.currentTmpId] = entrypoint;
    },

    updateEntrypoint: (draft, {entrypointId, entrypointPath}) => {
        const news = draft.newsById[draft.currentTmpId];
        news.entrypointId = entrypointId;
        news.entrypointPath = entrypointPath;
    },

    addNewsItem: draft => {
        const curTmepId = _.uniqueId();
        draft.currentTmpId = curTmepId;
        draft.tmpIds.push(curTmepId);
        draft.newsById[curTmepId] = {...INIT_NEWS};
        draft.dirty = true;
    },

    deleteNewsItem: (draft, tmpId) => {
        const {currentTmpId, tmpIds, newsById} = draft;
        const index = tmpIds.indexOf(tmpId);
        if (index < 0) {
            return;
        }

        // 如果 tmpId 在顶部，则下移一位，否则上移一位
        let nextId = currentTmpId;
        if (tmpId === currentTmpId) {
            if (index === 0) {
                nextId = tmpIds[1];
            } else {
                nextId = tmpIds[index - 1];
            }
        }

        const ids = tmpIds.filter(id => id !== tmpId);
        const byId = _.omit(newsById, tmpId);
        draft.tmpIds = ids;
        draft.newsById = byId;
        draft.currentTmpId = nextId;
        draft.dirty = true;
    },

    /**
     * 上下移动。
     *
     * @param draft
     * @param tmpId 临时 id
     * @param to -1：上移， 1：下移
     */
    moveNewsItem: (draft, {tmpId, to}) => {
        const {tmpIds} = draft;
        const index = tmpIds.indexOf(tmpId);
        const ids = [...tmpIds];

        // 从原位置删除
        ids.splice(index, 1);

        ids.splice(index + to, 0, tmpId);

        draft.tmpIds = ids;
        draft.dirty = true;
    },

    activeNewsItem: (draft, tmpId) => {
        draft.currentTmpId = tmpId;
    },
};
export default actions;
